import React from 'react';
import { X } from 'lucide-react';
import NavItem from './NavItem';
import { useLanguage } from '../../contexts/LanguageContext';
import { NavItem as NavItemType } from '../../types/navigation';

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  items: NavItemType[];
}

const MobileNav = ({ isOpen, onClose, items }: MobileNavProps) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative w-64 h-full bg-white shadow-xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="font-bold text-lg">{t('nav.menu')}</h2>
          <button
            onClick={onClose}
            className="p-2"
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>
        <div className="py-4">
          {items.map((item) => (
            <NavItem
              key={item.key}
              href={item.href}
              onClick={onClose}
              mobile
            >
              {t(item.key)}
            </NavItem>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileNav;